import React from 'react';

const Footer = () => {
    return (
        <div className='bg-light'>
            <p className='text-center py-4'>Copyright 2022 Dhaka Times. All rights reserved.</p>
        </div>
    );
};

export default Footer;